module.exports = __webpack_public_path__ + "img/base_activites_baignade.b76ae0ad.svg";